import React, { createContext } from 'react';

// Définir le type pour les données du contexte chatbot
export interface ChatbotContextDataType {
  requestId: number | null;
  messages?: { content: string; role: 'user' | 'assistant' }[];
  isCompleted?: boolean;
  source?: string; // D'où vient la demande d'ouvrir le chatbot (ex: 'evaluation_click')
  timestamp?: number; // Pour potentiellement vérifier la fraîcheur
}

// Définir le type pour la valeur complète du contexte (données + setter)
interface ChatbotContextType {
  chatbotContext: ChatbotContextDataType | null;
  setChatbotContext: React.Dispatch<React.SetStateAction<ChatbotContextDataType | null>>;
}

// Créer le contexte avec une valeur par défaut
// Le setter par défaut ne fait rien, il sera remplacé par le Provider
export const ChatbotContext = createContext<ChatbotContextType>({
  chatbotContext: null,
  setChatbotContext: () => null, 
}); 